'use strict'

import md5 from 'blueimp-md5'

export default function(event, teamRefId) {
   if (!event) {
      console.error('No `event` param passed')
   } else if (!teamRefId) {
      console.error('No `teamRefId` param passed')
   }
   if (!event || !teamRefId) {
      return
   }

   const files = (event.target && event.target.files) || (event.dataTransfer && event.dataTransfer.files)
   const file = files && files.length && files[0]

   if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
      console.error(`The file type "${file.type}" is not supported.`)
   }

   // Append md5 content hash to "fingerprint" the image for Imgix cache invalidation
   const fileName = file.name
   const fileNameExtension = fileName.substr(fileName.lastIndexOf('.')).toLowerCase() // Note: keeps the preceeding `.`
   const fileNameNoExtension = fileName.substr(0, fileName.lastIndexOf('.')) // Note: also removes the `.`
   file.nameWithHash = teamRefId + '/' + fileNameNoExtension + '-' + md5(file) + fileNameExtension

   return file
}
